import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  VStack,
  HStack,
  Text,
  Switch,
  Button,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';

export type EnabledModules = { [key: string]: boolean | null };

interface Props {
  isOpen: boolean;
  onClose: () => void;
  initialModules: EnabledModules;
  onSave: (modulesToSend: Record<string, boolean>) => Promise<void> | void;
  isSubmitting?: boolean;
}

export function EnabledModulesModal({
  isOpen,
  onClose,
  initialModules,
  onSave,
  isSubmitting,
}: Props) {
  const [localModules, setLocalModules] = useState<EnabledModules>({});

  useEffect(() => {
    if (isOpen) setLocalModules(initialModules || {});
  }, [isOpen, initialModules]);

  const handleModuleChange = (key: string, value: boolean) => {
    setLocalModules((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = async () => {
    const modulesToSend: Record<string, boolean> = {};
    Object.entries(localModules).forEach(([key, value]) => {
      if (value !== null) modulesToSend[key] = value as boolean;
    });
    await onSave(modulesToSend);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent display="flex" maxH="70vh">
        <ModalHeader>Edit Enabled Modules</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={0} flex="1" overflowY="auto">
          <VStack align="stretch" spacing={3}>
            {Object.entries(localModules).map(([key, value]) => (
              <HStack
                key={key}
                justify="space-between"
                p={3}
                borderWidth="1px"
                borderRadius="4px"
                borderColor="gray.200"
                bg="gray.50"
              >
                <VStack align="start" spacing={0}>
                  <Text fontSize="sm" fontWeight="500" color="text.primary">
                    {key}
                  </Text>
                  <Text fontSize="xs" color="text.secondary">
                    {value === true
                      ? 'Enabled'
                      : value === false
                      ? 'Disabled'
                      : 'Not Set'}
                  </Text>
                </VStack>
                <Switch
                  isChecked={value === true}
                  onChange={(e) =>
                    handleModuleChange(key, e.target.checked ? true : false)
                  }
                />
              </HStack>
            ))}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack justify="flex-end" w="full">
            <Button size="sm" variant="ghost" onClick={onClose}>
              Cancel
            </Button>
            <Button
              size="sm"
              variant="filled"
              isLoading={isSubmitting}
              onClick={handleSave}
            >
              Save
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
